<template>
  <div class="token-level-system bg--color-11">
    <div class="container-wrapper bg--color-02">
      <div class="token-level-system__container container-new">
        <div class="token-level-system__info flx flx--col">
          <span
            class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold"
          >
            {{ $t('tokenNew.levelSystemBlock.title') }}
          </span>

          <span
            class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-03 mt-12"
          >
            {{ $t('tokenNew.levelSystemBlock.subtitle') }}
          </span>
        </div>

        <div class="token-level-system__image">
          <img :src="require('@/assets/img/token/level-system.svg')">
          <!-- <img :src="require('@/assets/img/token/gifs/level-system.gif')"> -->
          <!-- <video
            loop
            autoplay
            muted
            playsinline
            class="how-to-deploy-block__video-block"
          >
            <source
              :src="require('@/assets/img/token/gifs/level-system.mp4')"
              type="video/mp4"
            >
            Your browser does not support the video tag.
          </video> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {},
}
</script>

<style lang="scss" scoped>
.token-level-system {
  &__container {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    gap: toRem(22px);

    @include bp(m) {
      grid-template-columns: 1fr 1fr;
      gap: toRem(24px);
    }
  }

  &__image {
    text-align: center;

    @include bp(m) {
      text-align: right;
    }

    img,
    video {
      max-width: 100%;

      @include bp(m) {
        max-width: 60%;
      }
    }
  }
}
</style>
